import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  chats = 'chats',
  chat = 'chat',
  chatDocument = 'chatDocument',
}

enum ExternalRoutesIds {
  agentContext = 'agentContext',
  projectChat = 'projectChat',
  pulses = 'pulses',
}

export const chatsRouteRef = createRouteRef({ id: RoutesIds.chats });

export const rootRouteRef = chatsRouteRef;

export const chatRouteRef = createSubRouteRef({
  id: RoutesIds.chat,
  parent: rootRouteRef,
  path: '/:id',
});

export const chatDocumentRouteRef = createSubRouteRef({
  id: RoutesIds.chatDocument,
  parent: rootRouteRef,
  path: '/:id/documents/:documentId',
});

export const agentContextRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.agentContext,
  optional: true,
});

export const projectChatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.projectChat,
  params: ['id', 'chatId'],
  optional: true,
});

export const Routes = {
  chats: chatsRouteRef,
  chat: chatRouteRef,
  chatDocument: chatDocumentRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const pulsesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.pulses,
  optional: true,
});

export const ExternalRoutes = {
  agentContext: agentContextRouteRef,
  projectChat: projectChatRouteRef,
  pulses: pulsesRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
